import React from 'react';
import NotFound from '../../NotFound';
import PrismicReact from 'prismic-reactjs';
import styles from './About.scss';

export default class About extends React.Component {
  
  state = {
    doc: null,
    notFound: false,
  }

  componentWillMount() {
    this.fetchPage(this.props);
  }

  componentWillReceiveProps(props) {
    this.fetchPage(props);
  }

  componentDidUpdate() {
    this.props.prismicCtx.toolbar();
  }

  fetchPage(props) {
    if (props.prismicCtx) {
      // We are using the function to get a document by its uid
      return props.prismicCtx.api.getSingle('about', (err, doc) => {
        if (doc) {
          // We put the retrieved content in the state as a doc variable
          this.setState({ doc });
        } else {
          // We changed the state to display error not found if no matched doc
          this.setState({ notFound: !doc });
        }
      });
    }
    return null;
  }

  render() {
    if (this.state.doc) {
        return (
            <div className={styles.about}>
                <h1>{PrismicReact.RichText.asText(this.state.doc.data.title)}</h1>
                {PrismicReact.RichText.render(this.state.doc.data.about_me, this.props.prismicCtx.linkResolver)}
                {this.state.doc.data.skills.map(function(skill, index) {
                  return(
                    <div key={'skill_' + index}>
                        <span>{PrismicReact.RichText.asText(skill.name)}</span>
                        <span>{skill.rating}</span>
                    </div>
                  );
                })}
            </div>
        );
    } else if (this.state.notFound) {
        return <NotFound />;
    }
    return <h1>Loading</h1>;
  }
}


// WEBPACK FOOTER //
// ./src/Pages/About/About.js